/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1MutualFundsJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_STATE_ENTITY_NAME = 'ixc.mutualfunds.v1.MutualFundsJob';
export const ixcMutualfundsV1MutualFundsJobStateEntity = new schema.Entity<IxcMutualfundsV1MutualFundsJobState>(IXC_MUTUALFUNDS_V1_MUTUAL_FUNDS_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'mutualFundsJobId' });

